<div class="form-group">
	<label *ngIf="hasTitle()">{{ title }}</label>
	<div class="kt-checkbox-list">
		<ng-content></ng-content>
	</div>
</div>
